import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Calendar } from 'primereact/calendar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Tag } from 'primereact/tag';
import { getAuthData } from '../../service/auth';

import api from './../../service/api';
import { formatPhone } from '../../service/format';
import { calculateDateInterval } from '../../service/handle';

const Driver = () => {
    let emptyDriver = {
        code: null,
        name: '',
        phone: '',
        address: '',
        date_birth: '',
        license_number: null,
        license_expiration: '',
        createdat: 0,
        password: ''
    };

    const [drivers, setDrivers] = useState([]);
    const [driverDialog, setDriverDialog] = useState(false);
    const [deleteDriverDialog, setDeleteDriverDialog] = useState(false);
    const [driver, setDriver] = useState(emptyDriver);
    const [selectedDrivers, setSelectedDrivers] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);
    const authData = getAuthData();

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _driver = { ...driver };
        _driver[`${name}`] = val;

        setDriver(_driver);
    }

    const openNew = () => {
        setDriver(emptyDriver);
        setSubmitted(false);
        setDriverDialog(true);
        setDisabled(false);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setDriverDialog(false);
        setDisabled(false);
    }

    const hideDeleteDriverDialog = () => {
        setDeleteDriverDialog(false);
    }

    const editDriver = (driver) => {
        setDriver({ ...driver });
        setDriverDialog(true);
    }

    const confirmDeleteDriver = (driver) => {
        setDriver({ ...driver });
        setDeleteDriverDialog(true);
    }

    const handleDriver = () => {
        if(!driver.name)
            return setSubmitted(true);
        
        if(driver.date_birth)
            driver.date_birth = typeof driver.date_birth === 'number' ? driver.date_birth : driver.date_birth.getTime();
        else driver.date_birth = 0;
        if(driver.license_expiration)
            driver.license_expiration = typeof driver.license_expiration === 'number' ? driver.license_expiration : driver.license_expiration.getTime();
        else driver.license_expiration = 0;

        setSubmitted(false);
        setDisabled(true);

        if(!driver.code && !driver.email){
            setSubmitted(true);
            setDisabled(false);
            return toast.current.show({severity: 'warn', summary: 'Atenção', detail: 'Informe um e-mail de acesso!' , time: 4000});
        }
        
        if(!driver.code && !driver.password){
            setSubmitted(true);
            setDisabled(false);
            return toast.current.show({severity: 'warn', summary: 'Atenção', detail: 'Informe uma senha de acesso!' , time: 4000});
        }

        var uri = driver.code ? '/driver/update' : '/driver/create';
        api().post(uri, {...driver, code: (driver.code || authData.user.code )}).then(response => {
            if(response.status === 200 && response.data.result){
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listDrivers();
                hideDialog();
            } else {
                toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
                setDisabled(false);
            }
        });
    }

    const handleDeleteDriver = () => {
        setDeleteDriverDialog(false);
        api().delete('/driver/' + driver.code).then(response => {
            if(response.status === 200 && response.data.result) {
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listDrivers();
            } else toast.current.show({severity: 'error', summary: 'Erro', detail: response.data.message});
            setDriver(emptyDriver);
        });
    }

    const listDrivers = () => {
        api().get('/driver/list').then(response => {
            if(response.status === 200 && response.data.result){
                setDrivers(response.data.data.map(data => {
                    var timestampNow = Date.now();
                    if(data.license_expiration)
                        data.license_expiration_interval = (timestampNow < data.license_expiration ? 'Vencerá em ' : 'Venceu a ') + calculateDateInterval(data.license_expiration, timestampNow);
                    else data.license_expiration_interval = '-';
                    return data;
                }));
            }
        });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Novo" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        )
    }

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mt-2 mr-2" onClick={() => confirmDeleteDriver(rowData)} />
                <Button icon="pi pi-ellipsis-v" className="p-button-rounded p-button-info" onClick={() => editDriver(rowData)} />
            </div>
        );
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Gerenciar Motoristas</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar..." />
            </span>
        </div>
    );

    const productDialogFooter = (
        <>
            <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Salvar" onClick={handleDriver} loading={disabled} icon="pi pi-check" className="p-button-text"  />
        </>
    );
    const deleteDriverDialogFooter = (
        <>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDriverDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDeleteDriver} />
        </>
    );

    useEffect(() => {
        listDrivers();
    }, []);
  
    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" left={leftToolbarTemplate}></Toolbar>

                    <DataTable ref={dt} value={drivers} selection={selectedDrivers} onSelectionChange={(e) => setSelectedDrivers(e.value)}
                        dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Listando {first} a {last} de {totalRecords} registros"
                        globalFilter={globalFilter} emptyMessage="Nenhum registro encontrado." header={header} responsiveLayout="scroll">
                        <Column field="name" header="Nome" sortable headerStyle={{ width: '24%', minWidth: '10rem' }}></Column>
                        <Column field="phone" body={rowData => rowData.phone ? <a href={"tel:" + rowData.phone.replace(/\D/g, '')}>{formatPhone(rowData.phone)}</a> : '-'}  header="Telefone" style={{ whiteSpace: 'nowrap' }}></Column>
                        <Column field="date_birth" body={rowData => (rowData.date_birth || 0) ? new Date(rowData.date_birth).toLocaleDateString('pt-br') : '-'} header="Data de Nascimento" sortable></Column>
                        <Column field="email" body={rowData => (rowData.email || '-')} header="E-mail de acesso"></Column>
                        <Column field="license_expiration_interval" style={{ whiteSpace: 'nowrap' }} header="Situação CNH"></Column>
                        <Column body={actionBodyTemplate} style={{ whiteSpace: 'nowrap' }}></Column>
                    </DataTable>

                    <Dialog visible={driverDialog} style={{ width: '450px' }} header="Motorista" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                        
                        <div className="field">
                            <label htmlFor="name">Nome</label>
                            <InputText disabled={disabled} id="name" value={driver.name} onChange={(e) => onInputChange(e, 'name')} required autoFocus className={classNames({ 'p-invalid p-error': submitted && !driver.plate })} />
                            {submitted && !driver.name && <small className="p-invalid p-error">O nome é obrigatório.</small>}
                        </div>
                        <div className="field">
                            <label htmlFor="address">Endereço</label>
                            <InputText disabled={disabled} id="address" value={driver.address} onChange={(e) => onInputChange(e, 'address')} required />
                        </div>

                        <div className="field">
                            <label htmlFor="phone">Telefone</label>
                            <InputText disabled={disabled} id="phone" value={driver.phone} onChange={(e) => onInputChange(e, 'phone')} required />
                        </div>

                        <div className="field">
                            <label htmlFor="date_birth">Data de Nascimento</label>
                            <Calendar id="date_birth" dateFormat='dd/mm/yy' locale='pt-br' value={new Date(driver.date_birth)} onChange={(e) => onInputChange(e, 'date_birth')} showIcon />
                        </div>
                        <div className="field">
                            <label htmlFor="license_number">Número da CNH</label>
                            <InputText disabled={disabled} maxLength={50} id="license_number" value={driver.license_number} onChange={(e) => onInputChange(e, 'license_number')} required />
                        </div>
                        <div className="field">
                            <label htmlFor="license_expiration">Data de Vencimento da CNH</label>
                            <Calendar id="license_expiration" dateFormat='dd/mm/yy' locale='pt-br' value={new Date(driver.license_expiration || '')} onChange={(e) => onInputChange(e, 'license_expiration')} showIcon />
                        </div>
                        
                        {!driver.code ? 
                        (
                            <>
                                <div className='field'>
                                    <label htmlFor="email">E-mail de acesso</label>
                                    <InputText disabled={disabled} id="email" value={driver.email} onChange={(e) => onInputChange(e, 'email')} required />
                                    {submitted && !driver.email && <small style={{ marginLeft: 10 }} className="p-invalid p-error">O e-mail é obrigatório.</small>}
                                </div>
                                <div className='field'>
                                    <label htmlFor="password">Senha</label>
                                    <Password disabled={disabled} 
                                    weakLabel='Fraca'
                                    mediumLabel='Média'
                                    strongLabel='Forte'
                                    promptLabel='Sua senha'
                                    id="password" value={driver.password} onChange={(e) => onInputChange(e, 'password')} required />
                                    {submitted && !driver.password && <small style={{ marginLeft: 10 }} className="p-invalid p-error">A senha é obrigatório.</small>}
                                </div>
                            </>
                        ) : ''}
                        
                    </Dialog>

                    <Dialog visible={deleteDriverDialog} style={{ width: '450px' }} header="Atenção" modal footer={deleteDriverDialogFooter} onHide={hideDeleteDriverDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {driver && <span>Você tem certeza que deseja remover este motorista?</span>}
                        </div>
                    </Dialog>
                    
                </div>
            </div>
        </div>
    );
}

export default Driver;